/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Data_ValidationInputs */

const en_data_validation = /** @type {(inputs: Data_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Validation`)
};

const nl_data_validation = /** @type {(inputs: Data_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevensvalidatie`)
};

/**
* | output |
* | --- |
* | "Data Validation" |
*
* @param {Data_ValidationInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const data_validation = /** @type {((inputs?: Data_ValidationInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Data_ValidationInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_data_validation(inputs)
	return en_data_validation(inputs)
});